import React, { useState } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import '../Shared/CSS/table.css';
import PropertyPopup from '../Shared/Popups/PropertyPopup';

import { saveEditData } from '../../actions/plotAction';
import { useHistory } from 'react-router';
import TableButton from '../Shared/Buttons/TableButton';

const PlotTable = ( props: any ) => {

    console.log( 'in plot table: ', props );

    const [ popupOpen, setPopupOpen ] = useState( false );
    const [ propertyData, setPropertyData ] = useState( [ ] );
    const routerHistory = useHistory();
    const popupHandler = ( ) => {

        setPopupOpen( popupOpen => !popupOpen );

    }

    const setProperty = ( property: any ) => {

        setPropertyData( property );

        if ( property ) {
            console.log( popupOpen );
            popupHandler( );

        }

    }
    
    

    return (

        <PlotTableWrapper>
            <div className="wrapper">

                <h1> Properties </h1><br/>
    
                <div className="table">
                    
                    <div className="row header">
                        <div className="cell">
                            SNo.
                        </div>
                        <div className="cell">
                            Property Name
                        </div>
                        <div className="cell">
                            Type
                        </div>
                        <div className="cell">
                            Location
                        </div>
                        <div className = 'cell'>
                            Show
                        </div>
                        <div className = 'cell'>
                            Edit
                        </div>
                        
                    </div>
                    {
                        props.plotInfo.map( ( item: any, index: number ) => {

                            return (

                                <div className = 'row' key = { item._id } >
                                    <div className = 'cell' data-title = 'SNo'>
                                        { index + 1 }
                                    </div>
                                    <div className = 'cell' data-title = 'Property Name'>
                                        { item.propertyName }
                                    </div>
                                    <div className = 'cell' data-title = 'Type'>
                                        { item.type } ( { item.subType } )
                                    </div>
                                    <div className = 'cell' data-title = 'Address'>
                                        { item.location }
                                    </div>
                                    <div className = 'cell' data-title = 'Show Property'>
                                        {/* <button onClick = { ( ) => setProperty( item ) } >show</button> */}
                                        <TableButton actionHandler = { ( ) => setProperty( item ) }
                                        text = 'Show' type = 'normal' />
                                    </div>
                                    <div className = 'cell edit-btn' data-title = 'Edit Property'>
                                        {/* <TableButton  /> */}
                                        <TableButton actionHandler = { ( e: any ) => { 
                                            
                                            e.preventDefault( );
                                            console.log( 'edit clicked ' );
                                            props.saveEditData( item );
                                            routerHistory.push('/add-plots?edit=true');


                                        } } text = "Edit" type = 'green'/>
                                    </div>

                                </div>

                            )
                        } )
                    }        
                    
                </div>
                {
                    popupOpen ?
                    <div className="popup-model">
                        <PropertyPopup data = { propertyData } popupHandler = { popupHandler } />
                    </div>
                    :
                    ''
                }
            </div>
        </PlotTableWrapper>
    
    );

}

const mapStateToProps = ( state: any ) => ( { 

    isAuthenticated: state.admin.isAuthenticated,
    loading: state.plot.loading,
    msg: state.plot.msg,
    plotInfo: state.plot.plotInfo

} );

export default connect( mapStateToProps, {

    saveEditData

} ) ( PlotTable );



// export default PlotTable;

const PlotTableWrapper = styled.div`



`;

